import React from 'react'
import { useTheme } from '@emotion/react'
import { Icon } from '../Common/Icon'
import {
  BiometricsStyled,
  BiometricsCallToActionStyled,
  BiometricsIconContainerStyled,
  BiometricsFooterStyled,
  BiometricsNeedHelpButtonStyled,
  BiometricsCloseButtonStyled,
} from './Biometrics.styled'

type BiometricsProps = {
  onSkip?: VoidFunction
}

export const Biometrics = ({ onSkip }: BiometricsProps) => {
  const theme = useTheme()

  return (
    <BiometricsStyled>
      <BiometricsCallToActionStyled>
        <BiometricsIconContainerStyled>
          <Icon type='cross' color={theme.colors.studio['500']} size='8rem' />
        </BiometricsIconContainerStyled>

        <h1>
          Make logging in
          <br /> faster with
          <br /> biometrics
        </h1>

        <p>
          Enable biometrics to give
          <br /> you quicker access to your TABtouch
          <br /> account
        </p>
      </BiometricsCallToActionStyled>

      <BiometricsFooterStyled>
        <BiometricsNeedHelpButtonStyled
          size='lg'
          isFullWidth
          onClick={() => alert('TODO enable biometrics')}
        >
          Enable
        </BiometricsNeedHelpButtonStyled>
        <BiometricsCloseButtonStyled onClick={onSkip}>
          I&apos;ll do it later
        </BiometricsCloseButtonStyled>
      </BiometricsFooterStyled>
    </BiometricsStyled>
  )
}
